import { Link } from 'react-router-dom'
import logoColored from '../../assets/images/logo-colored.png'
import logoMark from '../../assets/images/logo-mark.png'
import { cn } from '../../lib/utils'

const WORDMARK_SIZE = {
  sm: 'h-8 w-auto',
  md: 'h-10 w-auto',
}

const MARK_SIZE = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
}

export function Logo({ variant = 'dark', size = 'md', linkToHome = true }) {
  const content =
    variant === 'light' ? (
      <span className="inline-flex items-center gap-2.5">
        <img
          src={logoMark}
          alt=""
          aria-hidden
          className={cn(MARK_SIZE[size], 'shrink-0 object-contain')}
        />
        <span className="font-display text-xl font-bold leading-none tracking-tight">
          <span className="text-white">Peer</span>
          <span className="text-gold">Med</span>
        </span>
      </span>
    ) : (
      <img
        src={logoColored}
        alt="PeerMed"
        className={cn(WORDMARK_SIZE[size], 'object-contain object-left')}
      />
    )

  if (!linkToHome) {
    return content
  }

  return (
    <Link to="/dashboard" className="inline-flex items-center" aria-label="PeerMed home">
      {content}
    </Link>
  )
}
